var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3272 5.58329V3.24996H9.66053V5.58329H14.3272ZM2.66053 7.91663V20.75H21.3272V7.91663H2.66053ZM23.6605 5.58329V23.0833H0.338867V5.58329H7.3272V3.24996C7.3272 1.96663 8.3772 0.916626 9.66053 0.916626H14.3272C15.6105 0.916626 16.6605 1.96663 16.6605 3.24996V5.58329H23.6605Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon_profile.b491a0778353449c883549273303bc03.svg";
export { ForwardRef as ReactComponent };